import constant from '@/constant.js'
import util from '@/util.js'

export default {
  getDesigners: function (cb) {
    var data = { sort: 'sortOrder', desc: false }
    util.apiHandler('post', `${constant.API_ROOT}/designer/findByCondition`, data, cb)
  },
  getDesigner: function (id, cb) {
    util.apiHandler('post', `${constant.API_ROOT}/designer/findbyid/${id}`, null, cb)
  }
}
